export var TAX_REPORT_DATA = "TAX_REPORT_DATA";
export var TAX_SUMMARIZE = "TAX_SUMMARIZE";
